import React, { useEffect, useState } from "reactn";
import { Table, Space, Button, Popconfirm, Row } from 'antd';
import { Link } from 'react-router-dom';
import firebaseDb from '../firebase';
import { doc, collection, getDocs, deleteDoc, query, orderBy} from 'firebase/firestore';
import { EditOutlined, CalendarOutlined, FieldTimeOutlined, DeleteOutlined, Loading3QuartersOutlined, CheckOutlined, CloseOutlined, PlusOutlined, PlaySquareOutlined, BarcodeOutlined } from "@ant-design/icons";

const Notifications = (props) => {
    let [data, setData] = useState([]);
    let [totalCount, setTotalCount] = useState(0)
    let [loading, setLoading] = useState(false);

    let handleTableChange = async () => {
        get();
    }

    let get = async () => {
        console.log("first")
        const notificationRef = collection(firebaseDb, 'notification');
        const notificationQuery = query(notificationRef, orderBy("order"));
        const notificationSnapshot = await getDocs(notificationQuery);
        const notificationList = notificationSnapshot.docs.map((doc) => {
            console.log(doc.data())
            return {
                id: doc.id,
                ...doc.data(),
                active: (doc.data().active ? <CheckOutlined /> : <CloseOutlined />),
            }
        });
        setLoading(false)
        setTotalCount(notificationList.length);
        setData(notificationList);
    }

    useEffect(() => {
        setLoading(true)
        get();
    }, [])

    let deleteRow = async (item_id) => {
        await deleteDoc(doc(firebaseDb, "notification", item_id));
        let newData = data.filter(el => el.id !== item_id);
        setData(newData)
    }

    let columns = [
        {
            title: 'Başlık',
            dataIndex: 'title',
            key: 'title',
            width: 100,

        },
        {
            title: 'Metin',
            dataIndex: 'text',
            key: 'text',
            width: 150,

        },
        {
            title: 'Saat',
            key: 'action',
            fixed: 'right',
            align: 'right',
            width: 50,
            render: (text, record) => (
                <Space size="small">
                    <Link className="link">
                        <Button className="button4" icon={<CalendarOutlined />}>
                            {record.date.toDate().toLocaleDateString('tr-TR')}
                        </Button>
                        <Button className="button4" icon={<FieldTimeOutlined />}>
                            {record.date.toDate().toLocaleTimeString('tr-TR')}
                        </Button>
                    </Link>
                </Space>
            ),
        },
        {
            title: 'Aktif',
            dataIndex: 'active',
            key: 'active',
            width: 50,
        },
        {
            title: 'Sıra',
            dataIndex: 'order',
            key: 'order',
            width: 50,
        },
        {
            title: 'İşlemler',
            key: 'action',
            fixed: 'right',
            align: 'right',
            className: 'editColumn',
            width: 50,
            render: (text, record) => (
                <Row className="gap-8" size="small">
                    <Link to={"/notifications/edit/" + record.id}>
                        <Button className="button-consultant" icon={<EditOutlined />}>Düzenle</Button>
                    </Link>
                    <Popconfirm
                        onConfirm={() => deleteRow(record.id)} title="Silmeyi Onaylıyor musunuz?"
                        okText="Onayla" cancelText="Vazgeç">
                        <Button type="danger" className="button4" icon={<DeleteOutlined />}>
                            Sil
                        </Button>
                    </Popconfirm>
                </Row>
            ),
        },
    ];

    return (
        <div>
            <div className="list-head">
                <div className="list-title">
                    <h1>{"Bildirimler"} </h1>
                </div>
                <div className="list-buttons div-buttons">
                    <Link to="/notifications/add">
                        <Button type="light" className="button4" icon={<PlusOutlined />} size="large">Yayın Ekle</Button>
                    </Link>
                </div>
            </div>
            <div className="table-wrap">
                <Table dataSource={data} columns={columns} loading={{ spinning: loading, indicator: <Loading3QuartersOutlined spin />, size: "large" }}
                    onChange={handleTableChange}
                    pagination={{
                        total: totalCount
                    }}
                />
            </div>
        </div>
    );
};

export default Notifications;
